import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';
import './Navbar.css';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''} ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
      <div className="nav-content">
        <ul className={`nav-menu ${isMobileMenuOpen ? 'active' : ''}`}>
            <li>
              <Link to="home" smooth={true} duration={500} className="nav-link" onClick={closeMobileMenu}>
                Home
              </Link>
            </li>
            <li>
              <Link to="services" smooth={true} duration={500} className="nav-link" onClick={closeMobileMenu}>
                Services
              </Link>
            </li>
            <li>
              <Link to="solutions" smooth={true} duration={500} className="nav-link" onClick={closeMobileMenu}>
                Solutions
              </Link>
            </li>
            <li>
              <Link to="about" smooth={true} duration={500} className="nav-link" onClick={closeMobileMenu}>
                About
              </Link>
            </li>
            <li>
              <Link to="contact" smooth={true} duration={500} className="nav-link" onClick={closeMobileMenu}>
                Contact
              </Link>
            </li>
          </ul>
        <button 
          className={`mobile-menu-toggle ${isMobileMenuOpen ? 'active' : ''}`}
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </nav>
  );
};

export default Navbar;

